<template>
  <template v-if="link == 609612">
    <img
      class="img-fluid dyn-img"
      alt="nft image"
      :src="'/images/nfts/609612.gif'"
    />
  </template>
  <template v-else>
    <img
      class="img-fluid h-100 card_images"
      alt="nft image"
      :src="`/images/nfts/${link}.gif`"
      v-if="loading"
    />
    <video
      class="card_images"
      autoplay
      loop
      muted
      ref="video"
      @loadeddata="onVideoLoad"
      v-else
    >
      <source :src="loadVideo(link)" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <img
      class="img-fluid card_images optionl_img"
      alt="nft image"
      :src="`/images/nfts/${link}.gif`"
      v-if="tempImg"
    />
  </template>
</template>

<script>
export default {
  name: "VideoBlock",
  props: ["link"],
  data() {
    return {
      loading: true,
      tempImg: true,
    };
  },
  mounted() {
    this.loading = false;
  },
  methods: {
    onVideoLoad() {
      // const video = this.$refs.video;
      this.tempImg = false;
      // if (video.readyState === 4) {
      // }
    },
    loaded() {
      this.loading = false;
    },
    loadVideo(link) {
      return `/images/nfts/${link}.mp4`;
    },
  },
};
</script>
<style scoped>
video {
  width: 100%;
  height: 100%;
}
.multiple_cards img {
  height: 100%;
  width: 100%;
  padding: 2px 6px;
  border-radius: 12px;
}
.lg-card img {
  height: 100%;
  width: 100%;
  /* padding: 4px 8px; */
}
.dyn-img {
  aspect-ratio: 0 !important;
}
.inv-page .optionl_img {
  width: 106px;
  left: 8px;
  top: 7px;
  height: 172px;
}
.market-card .optionl_img {
  width: 115px;
  height: 161px;
  top: 35px;
  left: 48px;
}
.user-gun .optionl_img {
  width: 91px;
  height: 151px;
  top: 12px;
  left: 135px;
}
.user-chars .optionl_img {
  width: 87px;
  height: 147px;
  top: 12px;
  left: 11px;
}
.nftInner .optionl_img {
  width: 114px;
  height: 181px;
  top: 10px;
  left: 25px;
}
.refil-nft .optionl_img {
  width: 114px;
  height: 181px;
  top: 10px;
  left: 62px;
}
@media (max-width: 768px) {
  .nftInner .optionl_img {
    left: 14px;
  }
}
</style>
